import { RouterProvider, useRoutes } from 'react-router-dom'
import './App.css'
import { routes } from './routes/route'

function App() {
  const element = useRoutes(routes)

  return <>{element}</>
}

export default App
